module.exports = __webpack_public_path__ + "2fbbcca229d13a433e1bea1f4246e3a0.png";